import { render, staticRenderFns } from "./AdamHeaderUserProfile.vue?vue&type=template&id=0e8845c2&scoped=true"
import script from "./AdamHeaderUserProfile.vue?vue&type=script&lang=ts"
export * from "./AdamHeaderUserProfile.vue?vue&type=script&lang=ts"
import style0 from "./AdamHeaderUserProfile.vue?vue&type=style&index=0&id=0e8845c2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8845c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e8845c2')) {
      api.createRecord('0e8845c2', component.options)
    } else {
      api.reload('0e8845c2', component.options)
    }
    module.hot.accept("./AdamHeaderUserProfile.vue?vue&type=template&id=0e8845c2&scoped=true", function () {
      api.rerender('0e8845c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AdamHeaderUserProfile.vue"
export default component.exports